import _ from "lodash";
import { Box, Chip, LinearProgress, Typography } from '@mui/material';
import ErrorIcon from '@mui/icons-material/ErrorOutline';

type Props = {
    value: string,
    error: boolean
}

const StatusColumn = ({ value, error }: Props) => {    
    return (
        <Box sx={{ width: '100%' }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Box sx={{ width: '100%', mr: 1, color: error && _.isEmpty(value) ? 'red' : 'white' }}>                    
                    {error && _.isEmpty(value) && <><ErrorIcon color='error' sx={{float: 'left', mr: 1} } /> <Typography variant='subtitle1' sx={{ float: 'left' } }>Missing Data</Typography></>}
                    {!_.isEmpty(value) && value}                    
                </Box>
            </Box>
        </Box>
    )
}

export { StatusColumn }
export default StatusColumn;